import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import FinderPage from './pages/FinderPage';
import AboutPage from './pages/AboutPage';
import LegalPage from './pages/LegalPage';
import DomainsPage from './pages/DomainsPage';
import InstallationPage from './pages/InstallationPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/index" element={<FinderPage />} />
        <Route path="/domain/:domainId" element={<FinderPage />} />
        <Route path="/domains" element={<DomainsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/legal" element={<LegalPage />} />
        <Route path="/install" element={<InstallationPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
